
import DialogComponent from './dialog.vue'
const dialogDom = {
  install: function(Vue) {
    Vue.component('dialogDom', DialogComponent)
  }
}
export default dialogDom



// WEBPACK FOOTER //
// ./src/components/Dialog/index.js